import { PAGE_TYPE } from '@constants/crm/displayPageType';

// ============================================================================
// Page Type Constants
// ============================================================================

export const HISTORICAL_PAGE_TYPE = {
    BASIC_INFO: 'HISTORICAL_BASIC_INFO',
    APPLICATIONS: 'HISTORICAL_APPLICATIONS',
    ENROLLMENTS: 'HISTORICAL_ENROLLMENTS',
    DOCUMENTS: PAGE_TYPE.HISTORICAL_DOCUMENTS,
    NOTICES: PAGE_TYPE.HISTORICAL_NOTICES,
} as const;

export type HistoricalPageType = typeof HISTORICAL_PAGE_TYPE[keyof typeof HISTORICAL_PAGE_TYPE];

// ============================================================================
// Validation Constants
// ============================================================================

export const MIN_VALID_AMOUNT = 0;

// ============================================================================
// Display Constants
// ============================================================================

export const COLON = ':';
export const EMPTY_VALUE = '-';
export const DEFAULT_COVERAGE_YEAR = '2025';